import type { FC } from 'react';
import { ZIGGIZ_MARK_PATHS, ZIGGIZ_MARK_VIEW_BOX } from '@/lib/ziggiz-mark-paths';

/** The product mark supplies the geometry; no illustrative operational data. */
export const AuthBrandPanel: FC = () => (
  <div className="relative flex min-h-[32rem] flex-col justify-end overflow-hidden rounded-2xl border border-transparent p-12">
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox={ZIGGIZ_MARK_VIEW_BOX}
      className="absolute inset-x-0 top-10 mx-auto size-64 text-foreground/15"
      fill="currentColor"
    >
      {Object.entries(ZIGGIZ_MARK_PATHS).map(([name, d]) => (
        <path key={name} d={d} />
      ))}
    </svg>
    <p className="relative text-display leading-tight font-medium tracking-tight text-foreground">
      Security data.
      <br />
      Connected.
    </p>
  </div>
);
